/**
 * 微信SDK配置
 */

import { WECHAT_INIT_TIMEOUT, WECHAT_RECORD_API_LIST } from '@/constants/wechat.js'

/**
 * 获取微信SDK配置
 * @param {Object} signConfig - 后端返回的签名配置
 * @returns {Object} 微信SDK配置对象
 */
export function getWechatSDKConfig(signConfig) {
  return {
    debug: false, // 关闭微信SDK debug模式，使用VConsole即可
    appId: signConfig.appId,
    timestamp: parseInt(signConfig.timestamp),
    nonceStr: signConfig.nonceStr,
    signature: signConfig.signature,
    jsApiList: WECHAT_RECORD_API_LIST
  }
}

/**
 * 微信SDK配置选项
 */
export const wechatOptions = {
  // 初始化超时时间
  timeout: WECHAT_INIT_TIMEOUT,
  
  // 是否在初始化失败后自动重试
  autoRetry: false,
  
  // 是否输出详细日志
  verbose: import.meta.env.DEV
}

